import { useHookstate } from "@hookstate/core";
import { isEqual } from "lodash";
import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  PurchasesFilterState,
  purchasesFilterStore,
} from "../../../hookstate/purchasesFilterStore";

export function usePurchasesFilterState() {
  const filterState = useHookstate(purchasesFilterStore);
  const filters = useMemo(() => {
    const filters = new URLSearchParams();
    const { query } = filterState.get();

    if (query) {
      filters.set("q", query);
    }

    return filters;
  }, [filterState]);

  const [searchParams, setSearchParams] = useSearchParams();
  const [urlSettled, setUrlSettled] = useState(false);

  // Sync URL → Hookstate on mount and URL changes
  useEffect(() => {
    const newState: PurchasesFilterState = {
      query: searchParams.get("q") ?? undefined,
    };
    if (!isEqual(newState, filterState.get({ noproxy: true }))) {
      purchasesFilterStore.set(newState);
    }
    if (!urlSettled) {
      setUrlSettled(true);
    }
  }, [urlSettled, searchParams]);

  // Sync Hookstate → URL after URL is settled
  useEffect(() => {
    const searchFilters = new URLSearchParams(filters);

    if (urlSettled) {
      const newSearch = "?" + searchFilters.toString();
      if (newSearch !== location.search) {
        setSearchParams(newSearch);
      }
    }
  }, [urlSettled, filters]);

  return {
    urlSettled,
    filters,
  };
}
